import { render, staticRenderFns } from "./NavContractedItem.vue?vue&type=template&id=2009c930"
import script from "./NavContractedItem.vue?vue&type=script&lang=js"
export * from "./NavContractedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports